import * as React from 'react';
import { ReactComponent as ShieldSvg } from '../../assets/icons/mevo/ic-shield.svg';
import IconPattern, { IconProps } from './_IconPattern';

const ShieldIcon: React.FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={ShieldSvg} variantPlaces={[4, 5]} {...props} />;
};

export default ShieldIcon;
